import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()

export class LazyLoadLegacyStore {
    // eslint-disable-next-line rxjs/no-exposed-subjects
    public loaded: BehaviorSubject<boolean> = new BehaviorSubject(false);

    public loading = false;
}
